import React from "react";
import styled from "styled-components";
import egg from "../assets/egg.png";
import woods from "../assets/woods.png";

const Background = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  background-image: url(${woods});
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 10em;
  border-right: 2px solid #79559a;

  @media (max-width: 1440px) {
    width: 35%;
  }

  img {
    max-width: 50%;
    margin-top: 25em;
  }
`;

export default function EggContainer() {
  return (
    <Background>
      <img src={egg} alt="emile-egg" />
    </Background>
  );
}
